import styled from 'styled-components';

interface ContentProps {
  current?: number;
  menus?: any;
  onClick: (index: number) => void;
}

interface SelectProps {
  selected: boolean;
}

const Menus = ({ current, menus, onClick }: ContentProps) => {
  return (
    <MenusTemplateWrap>
      {menus.map((section: any, idx: number) => (
        <ContentWrap key={idx} selected={idx === current} onClick={() => onClick(idx)}>
          <MenuText selected={idx === current}>{section.name}</MenuText>
        </ContentWrap>
      ))}
    </MenusTemplateWrap>
  );
};

const MenusTemplateWrap = styled.div`
  width: 25rem;
  height: 100%;
  padding-top: 20px;
  background: linear-gradient(0deg, #000000 0%, #00315c 100%);
`;
const ContentWrap = styled.div<SelectProps>`
  text-align: center;
  align-content: center;
  width: calc(100% - 60px);
  height: 3.4375rem;
  cursor: pointer;
  margin: 30px;
  background: ${(props) =>
    props.selected ? 'radial-gradient(#CF1900, #000000)' : 'radial-gradient(#165B9D, #000000)'};
  border-radius: 0.625rem;
  border: 1px solid;
  border-color: ${(props) => (props.selected ? '#CF1900' : '#0094FF')};
`;
const MenuText = styled.div<SelectProps>`
  color: #ffffff;
  font-family: Inter;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
`;

export default Menus;
